import NewsCard from "./NewsCard";
import ".././styles/NewsAnnouncementsPreview.css"

import { HashLink as Link } from 'react-router-hash-link';
import { useState, useEffect } from "react";

const RSS2JSON_API_KEY = 'unrobsdshc0uiipzo2eqw63dccehc2xnxrdb5oax';

function NewsAnnouncementsPreview() {
    const [feed, setFeed] = useState([]);
    
        useEffect(() => {
            const fetchFeed = async () => {
                try {
                // Use rss2json.com to get the RSS. To get the RSS of substack is to put /feed at the end
                // of the link
                    const rssFeedUrl = 'https%3A%2F%2Fthenewpccm.substack.com%2Ffeed';
                    const apiUrl = `https://api.rss2json.com/v1/api.json?rss_url=${rssFeedUrl}&api_key=${RSS2JSON_API_KEY}`;

                    const res = await fetch(apiUrl);
                    const data = await res.json();
                    const allItems = data.items || [];
                    setFeed(allItems);
                } catch (error) {
                    console.error("RSS fetch failed:", error);
                }
            };
    
            fetchFeed();
        }, []);

        const firstTwoItems = feed.slice(0, 3); //get the first two latest news

    return (
        <div className="container section news-announcements-preview prev-container">
            <h2 className="section-title">
                Latest News and Announcements
            </h2>
            <div className="desktop-news">
                {/* RSS Feed Output */}
                <div className="rss-feed">
                    {firstTwoItems.map((item, index) => (
                        <div key={index} className="rss-item">
                            <NewsCard
                                image={item.thumbnail}
                                title={item.title}
                                date={item.pubDate}
                                description={item.description}
                                link={item.link}
                            />
                        </div>
                    ))}
                </div>

                {/* <IframeResizer
                    className="newspreview-iframe"
                    license='GPLv3'
                    src="https://rss.app/embed/v1/list/wER5G4MT4nEWcaRC"
                    style={{ width: '100%',  flexGrow: '1', border: 'none' }}
                    waitForLoad
                /> */}
                

            </div>
            <rssapp-list id="3wm3vNMLrHdIR3SH"></rssapp-list>

            <Link to="/news#news" className=" news-view-more button-1" >
                View More
            </Link>
        </div>
    );
}

export default NewsAnnouncementsPreview;